import closeIcon from 'assets/icons/close.svg'
import { Modal } from 'components/Modal'
import { rapidMatrixColumns, rapidMatrixFootnotes, rapidMatrixRows, rapidRows } from 'constants/ProjectSetUpConstants'

interface RapidFrameworkModalProps {
  isOpen: boolean
  onClose: () => void
}

export const RapidFrameworkModal = ({ isOpen, onClose }: RapidFrameworkModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="rapid-modal">
      <div className="flex items-start justify-between gap-4 w-full mb-4 rapid-modal-sticky-header pt-6 px-6">
        <p className="headline-m">RAPID - Global Brands</p>
        <button onClick={onClose} aria-label="Close">
          <img src={closeIcon} alt="" width={16} height={16} />
        </button>
      </div>

      <div className="rapid-modal-legend px-6">
        {rapidRows.map(row => (
          <div key={row.letter} className="flex gap-2 items-center">
            <span className="rapid-badge" style={{ backgroundColor: row.color }}>
              {row.letter}
            </span>
            <span className="subtitle-s">{row.label}</span>
          </div>
        ))}
      </div>

      <div className="rapid-matrix-wrapper px-6">
        <div className="rapid-matrix-group">
          <table className="rapid-matrix rapid-matrix-task">
            <thead>
              <tr>
                <th className="rapid-matrix-task-header">TASK</th>
              </tr>
              <tr>
                <th className="rapid-matrix-task-spacer" aria-hidden="true" />
              </tr>
            </thead>
            <tbody>
              {rapidMatrixRows.map(row => (
                <tr key={row.label}>
                  <th className={`${row.label === 'Meaningful brand role' ? 'flex justify-center h-[63px]' : ''}`}>
                    {row.label}
                  </th>
                </tr>
              ))}
            </tbody>
          </table>

          <table className="rapid-matrix rapid-matrix-role">
            <thead>
              <tr>
                <th className="rapid-matrix-role-header" colSpan={rapidMatrixColumns.length}>
                  ROLE
                </th>
              </tr>
              <tr>
                {rapidMatrixColumns.map(column => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rapidMatrixRows.map(row => (
                <tr key={row.label} className={row.highlight ? 'highlight' : ''}>
                  {row.cells.map((cell, index) => (
                    <td key={index} className={cell.length === 0 ? 'empty' : ''}>
                      {cell.map(letter => {
                        const rapidRow = rapidRows.find(r => r.letter === letter)
                        return (
                          <span key={letter} className="rapid-badge" style={{ backgroundColor: rapidRow?.color }}>
                            {letter}
                          </span>
                        )
                      })}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="flex gap-4 items-center w-full mt-4 px-6 pb-6">
        {rapidMatrixFootnotes.map(footnote => (
          <div key={footnote.mark} className="flex gap-1 items-center">
            <span className="subtitle-xxs">{footnote.mark}</span>
            <span className="body-xs color-neutral-80">{footnote.text}</span>
          </div>
        ))}
      </div>
    </Modal>
  )
}
